<template>
  <div class="feedback-content">
    <div class="feedback-title border-bottom">我的反馈</div>
    <div class="feedback-container">
      <!--<div v-if="noFeedback" class="default-empty">还没有反馈</div>-->
      <div v-if="noFeedback" class="absolute" style="top: 50%;left: 50%;transform: translate(-50%,-50%);user-select: none;">
        <img src="@/assets/images/default_empty.png"/>
        <div class="text-align-center font-16 color-999">
          还没有反馈
        </div>
      </div>
      <template v-else>
        <w-scrollbar wrap-style="overflow-x:hidden;" style="height: 100%;">
          <ul>
            <li v-for="(item,index) in feedback_list" :key="index">
              <div class="item border-bottom padding-10-0">
                <!--左边的部分：显示时间版块-->
                <div class="leftSide pointer" @click="fold(index)">
                  <div v-if="item.status !== 0">
                    <label class="label-title">回复时间：</label>
                    {{item.updatedAt | formatDate}}
                  </div>
                  <div>
                    <label class="label-title">反馈时间：</label>
                    {{item.createdAt | formatDate}}
                  </div>
                </div>
                <!--右边的部分： 用户评价版块-->
                <div class="rightSide">
                  <div class="pointer">
                    <div class="label-title text-align-right">
                      <template>状态：{{item.status | formatStatus}}</template>
                      <i class="w-icon-xiala" :class="{expand: item.isShow}" @click="fold(index)"></i>
                      <!--<i :class="item.isShow ? 'w-icon-xiala-copy' : 'w-icon-xiala'" @click="fold(index)"></i>-->
                    </div>
                  </div>
                  <!--<div class="pointer" v-if="+item.replyAt === 0" @click="fold(index)">-->
                  <!--<div class="label-title orange">-->
                  <!--状态：待回复-->
                  <!--<i :class="item.isShow ? 'w-icon-xiala-copy' : 'w-icon-xiala'"></i>-->
                  <!--</div>-->
                  <!--</div>-->
                  <!--<div v-else>-->
                  <!--<div class="label-title green pointer" @click="fold(index)">-->
                  <!--状态：已回复-->
                  <!--<i :class="item.isShow ? 'w-icon-xiala-copy' : 'w-icon-xiala'"></i>-->
                  <!--</div>-->
                  <!--<div v-if="+item.score === -1" v-show="item.isShow">-->
                  <!--<div class="state">对于回复您是否满意：</div>-->
                  <!--<div class="radio">-->
                  <!--<input type="radio" id="radio1" value="10" name="typeradio" v-model="item.pscore"/>-->
                  <!--<label for="radio1">满意</label>-->
                  <!--</div>-->
                  <!--<div class="radio">-->
                  <!--<input type="radio" id="radio2" value="0" name="typeradio" v-model="item.pscore"/>-->
                  <!--<label for="radio2">不满意</label>-->
                  <!--</div>-->
                  <!--<input class="radio" placeholder="其他意见" v-model="item.comment"/>-->
                  <!--<div class="button">-->
                  <!--<button class="btn_able" @click="submitComment(index)">提交</button>-->
                  <!--</div>-->
                  <!--</div>-->
                  <!--<div class="gray" v-show="item.isShow" v-else>-->
                  <!--<div class="state">对于回复您是否满意：</div>-->
                  <!--<div class="radio">-->
                  <!--<input type="radio" :checked="+item.score === 10" disabled="disabled"/>-->
                  <!--<label for="radio1">满意</label>-->
                  <!--</div>-->
                  <!--<div class="radio">-->
                  <!--<input type="radio" :checked="+item.score === 0" disabled="disabled"/>-->
                  <!--<label for="radio2">不满意</label>-->
                  <!--</div>-->
                  <!--<input class="radio" :placeholder="item.comment" disabled="disabled"/>-->
                  <!--<div class="button">-->
                  <!--<button class="btn_disable">提交</button>-->
                  <!--</div>-->
                  <!--</div>-->
                  <!--</div>-->
                </div>

                <!--中间的部分： 反馈内容版块-->
                <div class="middleSide">
                  <div class="label-title pointer" @click="fold(index)">反馈内容</div>
                  <div class="label-content" :class="{ellipsis: item.isShow}">{{item.content}}</div>
                  <collapse>
                    <div v-show="item.isShow">
                      <div class="label-img state" v-if="Array.isArray(item.attach) && item.attach.length">
                        <div v-for="(img, i) in item.attach" class="img-item pointer" :key="i">
                          <img :src="img.uri" height="80" width="80" @click="clickImg(img.uri)" :alt="img.name" />
                        </div>
                      </div>
                      <div v-if="+item.status === 0">
                        <div class="label-title state orange">处理状态：待处理</div>
                        <div>您的反馈已收到，稍后给您回复哦！</div>
                      </div>
                      <div v-else>
                        <div class="label-title state green">
                          <!--处理状态：已回复-->
                          处理状态：{{item.status | formatStatus}}
                        </div>
                        <!--多条回复-->
                        <template v-if="Array.isArray(item.feedbackFlow) && item.feedbackFlow.length">
                          <div>
                            <div class="feedback-comment" v-for="feedback in item.feedbackFlow" :key="feedback.comment">
                              {{feedback.comment}}
                            </div>
                          </div>
                        </template>
                        <!--第一条回复-->
                        <!--<div>{{item.processComment}}</div>-->
                        <div class="label-img state" v-if="Array.isArray(item.feedbackFlow) && item.feedbackFlow.length">
                          <div class="img-item" v-for="(img, k) in item.feedbackFlow.images" :key="k">
                            <img :src="img" height="80" width="80" @click="clickImg(img)"/>
                          </div>
                        </div>
                      </div>
                    </div>
                  </collapse>
                </div>
              </div>
            </li>
          </ul>
        </w-scrollbar>
      </template>
    </div>
    <div class="page-num">
      <w-pagination
        class="page"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 30]"
        :page-size="count"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
      ></w-pagination>
    </div>
  </div>
</template>
<script>
import MyFeedbackService from '@/assets/service/feedback'
import {formatDate} from '@/assets/utils/Date'
import {getCookie} from '@/assets/utils/CommonUtil'
import { Collapse } from '@/components/common'

export default {
  name: 'FeedbackList',
  data () {
    return {
      feedback_list: [],
      noFeedback: false,
      // showImgView: false,
      imgSrc: '',
      total: 0, // 反馈列表长度
      page: 1, // 页数
      count: 10, // 每页的个数
      gid: getCookie('ZJYTOKEN'),
      headers: {
        Authorization: getCookie('opToken'),
        // "Content-type": "application/x-www-form-urlencoded"
        'Content-type': 'application/json'
      }
    }
  },
  methods: {
    // 获取意见反馈列表
    getList () {
      let _self = this
      // let token = getCookie('ZJYTOKEN');
      let params = {
        pageSize: _self.count,
        pageNum: _self.page - 1
      }
      MyFeedbackService.getFeedbackList(params).then(res => {
        if (+res.code === 200) {
          _self.total = res.data.totalElements
          if (!res.data.list || res.data.list.length === 0) {
            this.noFeedback = true
            return
          }
          // let feedbackList = res.data.list.map((item, index) => {
          //   if (item.images) {
          //     item.images.map((img, index) => {
          //       item.images[index] = img + '/resize,w_80'
          //     })
          //   }
          //   return {
          //     ...item,
          //     pscore: -1,
          //     isShow: false
          //   }
          // })
          // _self.feedback_list = feedbackList
          _self.feedback_list = res.data.list
        }
      })
    },
    // 切换每页显示数量
    handleSizeChange (val) {
      this.page = 1
      this.count = val
      this.getList()
    },
    // 切换页码
    handleCurrentChange (val) {
      this.page = val
      this.getList()
    },
    // 展开折叠
    fold (index) {
      this.feedback_list[index].isShow = !this.feedback_list[index].isShow
      this.$set(this.feedback_list, index, this.feedback_list[index])
    },
    // 预览图片
    clickImg (img) {
      // img = img.replace('w_80', 'w_1300')
      this.$viewImage({
        zIndex: 2001,
        images: [img]
      })
    },
    // 提交评价
    submitComment (index) {
      let _self = this
      // let token = getCookie('ZJYTOKEN');
      let params = {
        score: this.feedback_list[index].pscore,
        comment: this.feedback_list[index].comment
      }
      let query = this.feedback_list[index].id

      if (+params.score === -1) {
        this.$confirm({
          message: '请您先勾选满意或不满意后再提交',
          title: '提示',
          submit: (data) => {

          },
          submitText: '确定',
          noCancelBtn: true
        })
        return
      }
      MyFeedbackService.feedbackComment(params, query).then(res => {
        if (+res.code === 200) {
          _self.getList()
        } else {
          this.$confirm({
            message: '失败了，请稍后重试！',
            title: '警告提示',
            submit: (data) => {

            },
            submitText: '确定',
            noCancelBtn: true
          })
        }
      })
    }
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val && val !== oldVal) {
          this.getList()
        }
      },
      deep: true
    }
  },
  filters: {
    formatDate (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy年MM月dd日')
    },
    formatStatus (status) {
      // -1 已删除 0 默认 4 未采纳 6 已采纳 10 已确认 20 已经回复 30 用户回复 40 关闭
      let statusString = ''
      switch (status) {
        case -1:
          statusString = '已删除'
          break
        case 0:
          // statusString = '默认'
          statusString = '待处理'
          break
        case 4:
          statusString = '未采纳'
          break
        case 6:
          statusString = '已采纳'
          break
        case 10:
          statusString = '已确认'
          break
        case 20:
          statusString = '已经回复'
          break
        case 30:
          statusString = '用户回复'
          break
        case 40:
          statusString = '关闭'
          break
        default:
          statusString = ''
      }
      return statusString
    }
  },
  mounted () {
    this.getList()
  },
  components: {
    Collapse
  }
}
</script>
<style lang="less" type="text/less" scoped>
  .feedback-content {
    height: 100%;
    box-sizing: border-box;
  }

  .feedback-title {
    padding-left: 60px;
    text-align: left;
    font-size: 22px;
    font-weight: bold;
    height: 100px;
    line-height: 100px;
    box-sizing: border-box;
  }

  .feedback-container {
    height: calc(100% - 150px);
    overflow: hidden;
  }

  .line {
    margin: 0 auto;
    border-bottom: 1px solid #ccc;
    width: 100%;
  }

  .item {
    overflow: hidden;
    height: max-content;
    font-size: 12px;
    line-height: 18px;
  }

  .leftSide {
    float: left;
    margin-left: 60px;
    text-align: left;
  }

  .middleSide {
    margin-left: 260px;
    margin-right: 260px;
    text-align: left;
    .feedback-comment {
      word-break:break-all;
      padding: 2px 0;
      line-height: 24px;
      border-bottom: 1px dashed #cccccc;
    }
  }

  .rightSide {
    user-select: none;
    float: right;
    width: 200px;
    margin-right: 50px;
    text-align: left;
    .label-title {
      i.w-icon-xiala {
        transition: transform 0.3s;
        &.expand {
          transform-origin: center center;
          transform: rotate(-180deg);
        }
      }
    }
  }

  .button {
    line-height: 40px;

    .btn_able {
      width: 60px;
      height: 24px;
      font-size: 12px;
      background: #0098ff;
      color: #fff;
      cursor: pointer;
      border: none;
      border-radius: 4px;
      line-height: 20px;
    }

    .btn_able:hover {
      background: #0067ff;
    }

    .btn_disable {
      width: 60px;
      height: 24px;
      font-size: 12px;
      background: #25c80f;
      color: #fff;
      cursor: not-allowed;
      border: none;
      border-radius: 4px;
      line-height: 20px;
    }
  }

  .img-item {
    margin-right: 25px;
    display: inline-block;
    text-align: center;
  }

  .iconfont {
    margin-left: 10px;
    cursor: pointer;
  }

  .label-title {
    font-weight: bold;
    font-size: 14px;

    .w-icon-xiala {
      font-size: 12px;
      margin-left: 10px;
      line-height: 24px
    }

    .w-icon-xiala-copy {
      font-size: 12px;
      margin-left: 10px;
      line-height: 24px
    }
  }

  .label-content {
    margin-right: 100px;
    word-wrap: break-word;
  }

  .state {
    margin-top: 15px;
  }

  .radio {
    margin-top: 8px;
  }

  .pointer {
    cursor: pointer;
  }

  .green {
    color: #008001;
  }

  .orange {
    color: #fd8023;
  }

  .gray {
    color: #969896;
  }

  .rotate180 {
    transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
    display: inline-block;
  }

  .page-num {
    width: 100%;
    height: 50px;
    padding: 9px 17px;
    box-sizing: border-box;
    text-align: right;
  }

  .default-empty {
    margin-left: 0;
    padding-top: 360px;
    text-align: center;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    color: #999;
    font-weight: normal;
    background: transparent url("~@/assets/images/default_empty.png") center center no-repeat;
  }
</style>
